import React from "react";
import {
    history,
    Nullable,
} from "@data-force/app";
import {getTranslate, TranslateFunction} from "react-localize-redux";
import {connect} from "react-redux";
import HistoryParams from "../../../interfaces/historyParams";
import {getHistoryParams} from "../../../utils/common";
import StoreState from "../../../interfaces/store/storeState";
import {CLICK_EVENT, ENTER_KEY, EnvMap} from "../../../utils/constants";
import logo from "../../../assets/img/logo/logo.svg";
import logoDev from "../../../assets/img/logo/logo-dev.svg";
import logoStg from "../../../assets/img/logo/logo-stg.svg";
import logoStg1 from "../../../assets/img/logo/logo-stg1.svg";
import logoStg2 from "../../../assets/img/logo/logo-stg2.svg";
import fontLogo from "../../../assets/img/logo/font-logo.svg";
import fontLogoDev from "../../../assets/img/logo/font-logo-dev.svg";
import fontLogoStg from "../../../assets/img/logo/font-logo-stg.svg";
import fontLogoStg1 from "../../../assets/img/logo/font-logo-stg1.svg";
import fontLogoStg2 from "../../../assets/img/logo/font-logo-stg2.svg";
import "./Logo.scss";

interface OwnProps {
    dark: boolean
}

interface StateProps {
    translate: TranslateFunction
    env: string
}

type Props = StateProps & OwnProps;

const Logo: React.FC<Props> = (props: Props): React.ReactElement => {
    const translatePath: string = "components.common.Logo.Logo";

    const {translate, env, dark}: Props = props;

    const goTo = (event: React.MouseEvent | React.KeyboardEvent) => {
        const {key, type} = event as React.KeyboardEvent;

        if (type === CLICK_EVENT || key === ENTER_KEY) {
            const historyParams: Nullable<HistoryParams> = getHistoryParams();
            history.push(`/${historyParams?.idpId}/`);
        }
    };

    const getSrc = (): string => {
        let src: string = dark ? logo : fontLogo;
        switch (env) {
            case EnvMap.DEV:
                src = dark ? logoDev : fontLogoDev;
                return src;
            case EnvMap.STG:
                src = dark ? logoStg : fontLogoStg;
                return src;
            case EnvMap.STG1:
                src = dark ? logoStg1 : fontLogoStg1;
                return src;
            case EnvMap.STG2:
                src = dark ? logoStg2 : fontLogoStg2;
                return src;
            default:
                return src;
        }
    };

    return (
        <div
            className="df-logo"
            role="button"
            tabIndex={0}
            onClick={goTo}
            onKeyDown={goTo}
        >
            <img
                className={`df-logo-image-${env}`}
                src={getSrc()}
                alt={translate(`${translatePath}.logoLabel.text`) as string}
            />
        </div>

    );
};

function mapStateToProps(state: StoreState): StateProps {
    return {
        translate: getTranslate(state.localize),
        env: state.serviceProperties.env,
    };
}

export default connect(mapStateToProps)(Logo);
